import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import { BACKEND_URL } from "../../config";

import { Loading, Header, NotFound } from "../../components";
import { Page, Container } from "../../styles";

const Image = props => {
  const { imageId } = props.match.params;
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState();

  useEffect(() => {
    const fetchRequest = new AbortController();
    const signal = fetchRequest.signal;
    let isCanceled = false;

    const fetchImage = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/attachment/${imageId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include",
          signal
        });

        const json = await res.json();

        if (json && json.data) {
          if (!isCanceled) {
            setImage(JSON.parse(json.data));
            setLoading(false);
          }
        } else {
          if (!isCanceled) setLoading(false);
        }
      } catch (e) {
        if (!isCanceled) setLoading(false);
        console.log(e);
      }
    };

    fetchImage();

    return () => {
      if (fetchRequest !== undefined) {
        isCanceled = true;
        fetchRequest.abort();
      }
    };
  }, [imageId]);

  if (loading) {
    return (
      <Page>
        <Header title="Bild" />
        <Container>
          <Loading text="Hämtar bild..." />
        </Container>
      </Page>
    );
  }

  return (
    <Page>
      <Header title="Bild" />
      {image ? (
        <img
          src={`data:image/${image.extension};base64, ${image.image}`}
          alt={image.name}
          width="100%"
          key={image.id}
        />
      ) : (
        <Container>
          <NotFound text="Hoppsan, bilden hittades inte!" />{" "}
        </Container>
      )}
    </Page>
  );
};

export default withRouter(Image);
